import { z } from "zod";

export const dataFreshnessSchema = z.object({
  state: z.enum(["current", "pending"]),
  updatedAt: z.string().datetime().nullable(),
  throughDate: z.string().date().nullable(),
});

export const dataMaintenanceStateSchema = z.enum([
  "preparing",
  "updating",
  "ready",
  "unverified",
  "delayed",
  "action_required",
  "unavailable",
  "paused",
]);
export const dataTaskProgressSchema = z.object({
  stage: z.enum([
    "scheduled",
    "queued",
    "running",
    "waiting_amazon",
    "ingesting",
    "completed",
    "failed",
    "stale",
    "action_required",
    "paused",
    "unavailable",
    "unknown",
  ]),
  tasks: z
    .object({
      queued: z.number().int().nonnegative(),
      running: z.number().int().nonnegative(),
      waiting_amazon: z.number().int().nonnegative(),
      ingesting: z.number().int().nonnegative(),
    })
    .optional(),
  totals: z
    .object({
      since: z.string().datetime(),
      total: z.number().int().nonnegative(),
      succeeded: z.number().int().nonnegative(),
      failed: z.number().int().nonnegative(),
      cancelled: z.number().int().nonnegative(),
      pending: z.number().int().nonnegative(),
    })
    .optional(),
  // False when queue evidence is unavailable or truncated; never implies zero work.
  complete: z.boolean(),
});
export const dataSourceStatusSchema = z.object({
  source: z.enum(["store_info", "catalog", "inventory", "ads", "sales"]),
  state: dataMaintenanceStateSchema,
  lastSuccessAt: z.string().datetime().nullable(),
  // Includes a verified empty snapshot: zero products is valid prepared data.
  hasData: z.boolean(),
  progress: dataTaskProgressSchema.optional(),
  reportQuality: z
    .object({
      status: z.enum(["unknown", "partial", "verified"]),
      startDate: z.string().date().nullable(),
      endDate: z.string().date().nullable(),
      verifiedCount: z.number().int().nonnegative(),
      expectedCount: z.number().int().nonnegative(),
      days: z.array(
        z.object({
          date: z.string().date(),
          status: z.enum(["synced", "pending", "unknown", "attention"]),
          recent: z.boolean(),
          updatedAt: z.string().datetime().nullable(),
        }),
      ),
    })
    .optional(),
});
export const workspaceDataStatusSchema = z.object({
  state: dataMaintenanceStateSchema,
  shops: z.array(
    z.object({
      shopId: z.string().uuid(),
      shopName: z.string(),
      marketplaceId: z.string(),
      marketplaceName: z.string(),
      amazonStoreName: z.string().nullable(),
      sources: z.array(dataSourceStatusSchema),
    }),
  ),
});
export type DataMaintenanceState = z.infer<typeof dataMaintenanceStateSchema>;
export type DataSourceStatus = z.infer<typeof dataSourceStatusSchema>;
export type WorkspaceDataStatus = z.infer<typeof workspaceDataStatusSchema>;
